export default {
  'Watermark': 'वॉटरमार्क',
  'Add Watermark Selection': 'वॉटरमार्क सेलेक्शन डालें',
}